import Component from '../Component';
export default class ImageComponent extends Component {
}
